import varAxios from "../../../Comman/axios";
import { GetAlarmFeedbackQuestionAnswerCPRList,getFeedbackAnswerList,GetFeedbackById, getApplicationFeedbackAnswerList,getRejectFeedbackAnswerListUrl } from '../../../Comman/apiEndPoints';

export const ANSWER_LIST_REQUEST = "(feedback) ANSWER_LIST_REQUEST";
export const ANSWER_LIST_SUCCESS = "(feedback) ANSWER_LIST_SUCCESS";
export const UPDATED_ALARM_STATUS_LIST_SUCCESS1 = "UPDATED_ALARM_STATUS_LIST_SUCCESS1";
export function getFeedbackAnswerListFunc(dispatch) {
    dispatch(
                    answerListSuccess(false,
                     '', 
                     0, 
                     0,
                     []
                    )
                );
    return (dispatch) => {
        dispatch(getAnswerListRequest(true));
        return varAxios.get(GetAlarmFeedbackQuestionAnswerCPRList)
            .then((response) => {
                console.log(response)
                dispatch(
                    answerListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.caseList
                    )
                );
            })
            .catch((error) => {
                
            })
    }
}
export function getAnswerListRequest(isLoading) {
    return {
        type: ANSWER_LIST_REQUEST,
        isLoading
    }
}
export function answerListSuccess(isLoading, message, statusCode, errorCode, list) {
    return {
        type: ANSWER_LIST_SUCCESS,
        isLoading,
        message,
        statusCode,
        errorCode,
        list
    }
}
export function getApplicationFeedbackAnswerListFunc(dispatch) {
    return (dispatch) => {
        dispatch(getAnswerListRequest(true));
        return varAxios.get(getApplicationFeedbackAnswerList)
            .then((response) => {
                console.log(response)
                dispatch(
                    answerListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.questionAnswerList
                    )
                );
            })
            .catch((error) => {
                
            })
    }
}
export function getRejectFeedbackAnswerListFunc(dispatch) {
    return (dispatch) => {
        dispatch(getAnswerListRequest(true));
        return varAxios.get(getRejectFeedbackAnswerListUrl)
            .then((response) => {
                dispatch(
                    answerListSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.questionAnswerList
                    )
                );
            })
            .catch((error) => {
                
            })
    }
  }
  export function getUpdatedAlarmStatusFunc(data) {
    return (dispatch) => {
       dispatch(getAnswerListRequest(true));
        return varAxios.post(GetFeedbackById, data)
            .then((response) => {
                dispatch(
                    updatedAlarmStatusSuccess(false,
                     response.data.Message, 
                     response.data.statusCode, 
                     response.data.errorCode,
                     response.data.answerList
                    )
                );
            })
            .catch((error) => {
                  dispatch(
                    updatedAlarmStatusSuccess(false,
                     '', 
                     null, 
                     null,
                     []
                    )
                );
            })
    }
}
export function updatedAlarmStatusSuccess(isLoading, message, statusCode, errorCode, list) {
    return {
        type: UPDATED_ALARM_STATUS_LIST_SUCCESS1,
        isLoading,
        message,
        statusCode,
        errorCode,
        list
    }
}